import React from 'react'
import Footer from '../Components/global/Footer'
import Header from '../Components/global/Header'
import SomethingWentWrongComponent from '../Components/global/SomethingWentWrongComponent'

const SomethingWentWrong = () => {
  return (
    <div style={{ backgroundColor: 'whitesmoke' }}>
      <Header />
      <SomethingWentWrongComponent />
      <Footer />
    </div>
  )
}

export default SomethingWentWrong
